import Api from './api'

import { getXAPIEnv, getXUserKey } from '@/plugins/account'

export default class {
  static list (showLoading = true) {
    return Api('store', 'users', 'get', null, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() }, showLoading)
  }

  static associate (user) {
    return Api('store', 'user', 'post', user, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() }, true)
  }

  static update(id, data) {
    return Api('store', `user/${id}`, 'put', data, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() }, true)
  }

  static associateCustomer (user) {
    return Api('store', 'customer', 'post', user, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() }, true)
  }

  static disassociate (id) {
    return Api('store', 'user/' + id, 'delete', null, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() }, true)
  }

  static customer(id, data) {
    return Api('store', `customer/${id}`, 'put', data, { 'x-api-env': getXAPIEnv(), 'x-user-key': getXUserKey() }, true)
  }
}
